/* Shared flip-flap motion engine — defined once, called by both galleries
   (#archer-flip-flap and #archer-flip-flap-2). Each caller passes its own
   stage/row IDs, faces, steps and alt default. Keeps the PDP section under
   Shopify's 256KB per-section limit; dir constants stay inline in the
   callers so the mirror→theme port still rewrites them to asset_url. */
window.ffRun = function (opts) {
  var stage = document.getElementById(opts.stageId);
  var row   = document.getElementById(opts.rowId);
  if (!stage || !row) return;

  var FACES = opts.faces;
  var STEPS = opts.steps;
  var altDefault = opts.altDefault || 'ARCHER result';

  function faceHTML(i) {
    var f = FACES[((i % FACES.length) + FACES.length) % FACES.length];
    if (f.photo) {
      return '<div class="ff-face"><img src="' + f.photo + '" alt="' + (f.alt || altDefault) + '" decoding="async"><div class="ff-shade"></div></div>';
    }
    return f.html.replace(/<\/div>$/, '<div class="ff-shade"></div></div>');
  }

  /* preload photography so mid-flip reveals never pop */
  FACES.forEach(function (f) { if (f.photo) { var im = new Image(); im.src = f.photo; } });

  /* ---- motion constants (taken from the Rico preview) ---- */
  var waveNum  = 0;
  var WAVE_MS  = 2500;   /* wave cadence */
  var STAGGER  = 95;     /* per-card delay, left to right */
  var FLIP_MS  = 950;    /* one 180-degree flip */
  var BACK_K   = 0.9;    /* anticipation + settle strength */
  var SHADE_MAX = 0.26;

  function easeInOutBack(t) {
    var c1 = BACK_K, c2 = c1 * 1.525;
    return t < 0.5
      ? (Math.pow(2 * t, 2) * ((c2 + 1) * 2 * t - c2)) / 2
      : (Math.pow(2 * t - 2, 2) * ((c2 + 1) * (t * 2 - 2) + c2) + 2) / 2;
  }

  var cards = [];

  function buildRow() {
    row.innerHTML = '';
    cards = [];
    /* drop any previous shrink-to-fit override so the probe measures clean */
    stage.style.removeProperty('--ff-card-w');
    stage.style.removeProperty('--ff-card-h');
    var w = stage.getBoundingClientRect().width;
    /* measure a real card — the CSS var holds an unevaluated clamp() string */
    var probe = document.createElement('div');
    probe.className = 'ff-card';
    row.appendChild(probe);
    var cardW = probe.getBoundingClientRect().width || 300;
    row.removeChild(probe);
    var gap = parseFloat(getComputedStyle(row).getPropertyValue('gap')) || 24;
    /* only cards that fit fully on screen — cards flip in place, so a
       clipped edge card would tease content that never fully reveals */
    var count = Math.max(2, Math.floor((w + gap) / (cardW + gap)));
    if (window.innerWidth <= 767) {
      count = 4;   /* mobile: fixed 2×2 grid of 4 — CSS grids .ff-row */
    } else if (count * cardW + (count - 1) * gap > w) {
      /* the 2-card minimum overflows a narrow stage (viewport-scaled cards
         inside e.g. the PDP buy column) — shrink cards to fit instead of
         letting overflow:hidden crop the outer edges. The stage height
         calc() reads the same var, so it shrinks with the cards. */
      cardW = Math.floor((w - (count - 1) * gap) / count);
      stage.style.setProperty('--ff-card-w', cardW + 'px');
      stage.style.setProperty('--ff-card-h', cardW + 'px');
    }

    for (var i = 0; i < count; i++) {
      var el = document.createElement('div');
      el.className = 'ff-card';
      var inner = document.createElement('div');
      inner.className = 'ff-card__inner';
      inner.innerHTML = faceHTML(i);              /* front */
      var back = document.createElement('div');
      back.innerHTML = faceHTML(i + 1);           /* placeholder; startFlip repaints */
      var backFace = back.firstChild;
      backFace.classList.add('ff-face--back');
      inner.appendChild(backFace);
      el.appendChild(inner);
      row.appendChild(el);
      cards.push({ el: el, inner: inner, rot: 0, faceIdx: i, anim: null });
      setCard(cards[i], 0, 0);
      (function (c) {
        c.el.addEventListener('pointerdown', function () { startFlip(c, performance.now()); });
      })(cards[i]);
    }

  }

  /* which DOM face is currently hidden, given the resting rotation */
  function hiddenFace(c) {
    var flips = Math.round(c.rot / 180);
    var faces = c.inner.querySelectorAll('.ff-face');
    return (flips % 2 === 0) ? faces[1] : faces[0];
  }

  function startFlip(c, now, step) {
    if (c.anim) return;
    step = step || STEPS[Math.floor(Math.random() * STEPS.length)];
    /* paint the incoming face onto the hidden side just before flipping */
    var hf = hiddenFace(c);
    var tmp = document.createElement('div');
    tmp.innerHTML = faceHTML(c.faceIdx + step);
    var fresh = tmp.firstChild;
    if (hf.classList.contains('ff-face--back')) fresh.classList.add('ff-face--back');
    hf.replaceWith(fresh);
    setCard(c, c.rot, 0);
    c.pendingStep = step;
    c.anim = { t0: now, from: c.rot, to: c.rot + 180 };
  }

  function finishFlip(c) {
    c.rot = c.anim.to;
    c.anim = null;
    c.faceIdx += c.pendingStep;
    setCard(c, c.rot, 0);
  }

  function setCard(c, rot, shade) {
    c.inner.style.transform = 'perspective(1100px) rotateY(' + rot.toFixed(3) + 'deg)';
    c.inner.style.setProperty('--shade', shade.toFixed(3));
    /* webkit ignores backface-visibility on clipped (overflow:hidden +
       radius) faces, so pick the visible side by hand from the angle */
    var ang = ((rot % 360) + 360) % 360;
    var backShowing = ang > 90 && ang < 270;
    var faces = c.inner.querySelectorAll('.ff-face');
    faces[0].style.visibility = backShowing ? 'hidden' : 'visible';
    if (faces[1]) faces[1].style.visibility = backShowing ? 'visible' : 'hidden';
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  buildRow();

  var resizeT;
  function queueRebuild() {
    clearTimeout(resizeT);
    resizeT = setTimeout(buildRow, 200);
  }
  window.addEventListener('resize', queueRebuild);
  /* the stage can also resize without a window resize — the parent column
     reflows as fonts/images/other scripts settle after load — so re-fit on
     real width changes too (height changes are our own var override; skip) */
  if ('ResizeObserver' in window) {
    var lastStageW = stage.getBoundingClientRect().width;
    new ResizeObserver(function () {
      var sw = stage.getBoundingClientRect().width;
      if (Math.abs(sw - lastStageW) < 1) return;
      lastStageW = sw;
      queueRebuild();
    }).observe(stage);
  }

  if (reduce.matches) return;                    /* static collage */

  var running = true;                            /* section in view + tab visible */
  var nextWaveAt = performance.now() + 900;

  function frame(now) {
    if (running) {
      if (now >= nextWaveAt) {
        var waveStep = STEPS[waveNum++ % STEPS.length];
        for (var i = 0; i < cards.length; i++) {
          (function (c, delay) {
            setTimeout(function () { startFlip(c, performance.now(), waveStep); }, delay);
          })(cards[i], i * STAGGER);
        }
        nextWaveAt = now + Math.max(WAVE_MS, cards.length * STAGGER + FLIP_MS + 350);
      }
      for (var k = 0; k < cards.length; k++) {
        var c = cards[k];
        if (!c.anim) continue;
        var p = (now - c.anim.t0) / FLIP_MS;
        if (p >= 1) { finishFlip(c); continue; }
        var e = easeInOutBack(Math.max(0, p));
        var rot = c.anim.from + 180 * e;
        var lit = Math.sin(Math.PI * Math.min(1, Math.max(0, e)));
        setCard(c, rot, lit * SHADE_MAX);
      }
    }
    requestAnimationFrame(frame);
  }

  /* pause offscreen; snap in-flight flips to their end so nothing strobes on return */
  function setRunning(on) {
    if (on && !running) {
      nextWaveAt = performance.now() + 900;
    }
    if (!on && running) {
      cards.forEach(function (c) { if (c.anim) finishFlip(c); });
    }
    running = on;
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      setRunning(entries[0].isIntersecting && !document.hidden);
    }, { threshold: 0.15 }).observe(stage);
  }
  document.addEventListener('visibilitychange', function () {
    setRunning(!document.hidden);
  });

  requestAnimationFrame(frame);
};
